import { ProductPage as BaseProductPage } from "@omni/components/components/ProductPage/productPage";
import { ProductPageProps } from "@omni/types/components/props/productPage.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";

import { ProductPageComponent } from "./productPage.component";

export const ProductPageContainer = ({
    sku,
    product,
    brandPagePath,
    contextAwareXfPath,
    features,
    eCommerce,
    infoCards,
    recommendSlider,
    usps,
    reviews,
    promoBanner,
    sliders
}: ProductPageProps<BaseStore.Etna>) => {
    return (
        <BaseProductPage
            sku={sku}
            product={product}
            brandPagePath={brandPagePath}
            contextAwareXfPath={contextAwareXfPath}
            features={features}
            eCommerce={eCommerce}
            infoCards={infoCards}
            recommendSlider={recommendSlider}
            reviews={reviews}
            promoBanner={promoBanner}
            sliders={sliders}
            usps={usps}
        >
            <BaseProductPage.Providers>
                <ProductPageComponent />
            </BaseProductPage.Providers>
        </BaseProductPage>
    );
};
